import { Loader } from "@googlemaps/js-api-loader";
import { ENVIRONMENT } from "./environment";

// side effects - declares window.google
export default await new Loader({
  apiKey: ENVIRONMENT.GOOGLE_MAPS_API_KEY,
  version: "3",
  libraries: ["places", "geometry", "drawing", "marker"],
}).load();
